export const isContentOne = () => {
  return window.CONFIG.DOMAIN === "content.one";
};
